import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

/**
 * API Call: Fetch mobile numbers from user_info table by city/village match
 * This function queries the backend to get all mobile numbers where city or village matches the selected cities
 * 
 * Expected Backend Logic:
 * 1. Receive array of selected cities/locations
 * 2. Query user_info table WHERE city IN (cities) OR village IN (cities)
 * 3. Return array of mobile numbers
 * 4. Frontend then inserts these into event_automation_list with event_id and other details
 * 
 * @param {Array} cities - Array of city names to search for
 * @param {Object} options
 * @param {boolean} options.showToast - Whether to show toast messages for success/empty/error states
 * @returns {Promise<Array>} - Array of mobile numbers matching the cities
 */
const getMobileNumbersByCity = async (
  cities = [],
  { showToast = true } = {},
) => {
  try {
    if (!cities || cities.length === 0) {
      if (showToast) {
        ErrorToast("Please select at least one city/location");
      }
      return null;
    }

    console.log("🔍 API CALL: Fetching mobile numbers by city");
    console.log("Selected Cities:", cities);

    const payload = {
      cities: cities, // Should be array of city names
    };

    console.log("📤 Sending Payload:", payload);

    const response = await AxiosPostMethod(
      "org/user/get-mobile-by-cities", // Backend endpoint to fetch mobile numbers by city
      payload
    );

    console.log("📥 API Response Status:", response?.status);
    console.log("📥 API Response Data:", response?.data);

    if (response?.status === 200) {
      const mobileNumbers = response.data?.data?.mobile_numbers || [];
      
      console.log("✅ Successfully fetched mobile numbers");
      console.log("Total numbers found:", mobileNumbers.length);
      console.log("Mobile numbers:", mobileNumbers);
      
      if (showToast) {
        SuccessToast(`Found ${mobileNumbers.length} mobile numbers for selected cities`);
      }
      return mobileNumbers;
    } else if (response?.status === 401) {
      console.error("❌ Unauthorized - Session expired");
      HandleLogout();
      return null;
    } else if (response?.status === 404) {
      console.warn("⚠️ No mobile numbers found for selected cities");
      if (showToast) {
        ErrorToast("No mobile numbers found for the selected cities");
      }
      return [];
    } else {
      console.error("❌ API Error:", response?.data?.message);
      if (showToast) {
        ErrorToast(
          response?.data?.message ||
          "Failed to fetch mobile numbers. Please try again."
        );
      }
      return null;
    }
  } catch (error) {
    console.error("❌ Exception in getMobileNumbersByCity:", error);
    if (showToast) {
      ErrorToast("An error occurred while fetching mobile numbers");
    }
    return null;
  }
};

export default getMobileNumbersByCity;
